import { render, staticRenderFns } from "./VProjectFilter.vue?vue&type=template&id=5b0242c8&"
import script from "./VProjectFilter.vue?vue&type=script&lang=js&"
export * from "./VProjectFilter.vue?vue&type=script&lang=js&"
import style0 from "./VProjectFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports